import React, { useEffect } from "react";
import {Div, Icon, Text} from "../../Kit";
import { Button } from "../../Kit/Button";
import { VerificationInput } from "../VerificaionInput/VerificationInput";
import { useForm, useWatch } from "react-hook-form";
import { Timer } from "../../SharedComponents";
import { useAuth } from "../../../Store/modules/auth/authSlice";
import { LoginSteps } from "../../../Constants/loginSteps";
import { useVerifyOtp } from "../../../Store/modules/auth/verifyOtp";
import { useOtp } from "../../../Store/modules/auth/otpSlice";
import { useGetOtpCode } from "../../../Store/modules/auth/getOtpCode";
import { useModal } from "../../../Store/modules/modal/modal";
import { Trans } from "react-i18next";
import { useLanguage } from "../../../Store/modules/language";
import {ArrowLeft, ArrowRight} from "iconsax-react";

export type VerifyOtpFormTypes = {
  username: string;
  code: string;
  afterLoginAction?: VoidFunction;
};
export const VerifyOtpForm: React.FC = () => {
  const { control, handleSubmit } = useForm<VerifyOtpFormTypes>();
  const { dispatchSetStep } = useAuth();
  const { dispatchVerifyOtp, verifyOtpLoading } = useVerifyOtp();
  const { otpData } = useOtp();
  const { dispatchGetOtpCode } = useGetOtpCode();
  const { modalProps } = useModal();
  const { code } = useWatch({ control });
  const { direction , locale } = useLanguage();

  const { username, duration } = otpData || {};
  const onSubmit = (data: VerifyOtpFormTypes) => {
    dispatchVerifyOtp({
      username,
      code: data.code,
      afterLoginAction: modalProps.afterLoginAction,
    });
  };

  useEffect(() => {
    if (code?.length === 5) {
      dispatchVerifyOtp({
        username,
        code,
        afterLoginAction: modalProps.afterLoginAction,
      });
    }
  }, [code, username]);

  const onResend = () => {
    dispatchGetOtpCode({ username });
  };

  return (
    <div className="flex flex-col justify-center mt-[24px] px-[20px] w-full ">
      <Text elementType="label" className="text-sm text-center" lineHeight={"24px"}>
        login.verifyOtp.enterCode
      </Text>
      <Text
        elementType="label"
        className="text-base text-center mt-1"
        translatable={false}
        fontWeight={500}
      >
        {username}
      </Text>
      <Div
        className="text-xs mt-[10px] flex items-center justify-between flex-row-reverse"
        dir={direction}
      >
        <div className="mt-2">
          <Timer duration={duration} />
        </div>

        {duration === 0 ? (
          <Div flex justifyContent="flex-start">
            <Text
              elementType="span"
              fontWeight={300}
              color="primary"
              className="text-sm mt-2 pointer"
              onClick={onResend}
            >
              login.verifyOtp.resendCode
            </Text>
          </Div>
        ) : null}
      </Div>
      <div className="flex flex-col justify-center mt-[14px] " dir="ltr">
        <VerificationInput control={control} name="code" />
      </div>
      <div className="mt-[22px] flex flex-col items-center">
        <Button
          title="login.verifyOtp.login"
          bg="primary"
          loading={verifyOtpLoading}
          onClick={handleSubmit(onSubmit)}
          className="w-full h-[45px] bg-[#009AFD]"
        />
          <div className="flex justify-center items-center mt-3">
            <Text
              elementType="span"
              fontWeight={500}
              fontSize={13}
              className="text-sm pointer me-[3px]"
              onClick={() => dispatchSetStep(LoginSteps.LoginForm)}
            >
              login.verifyOtp.changePhoneNumber
            </Text>
              <Icon Component={locale === "fa" ? ArrowLeft : ArrowRight} size={16} color="text" />
          </div>
      </div>
    </div>
  );
};
